import { useQuery } from "@tanstack/react-query";

import {
  NOTIFICATIONS_POLL_INTERVAL_MS,
  unreadNotificationsCountQueryKey,
} from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UnreadNotificationCountsResponse } from "@/types";

export function useGetUnreadNotificationsCount() {
  return useQuery({
    queryKey: unreadNotificationsCountQueryKey,
    refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS,
    queryFn: async () => {
      const path = "notifications/unread-count";
      const res = await guacHttpClient.get<
        UnreadNotificationCountsResponse,
        HttpResponse<UnreadNotificationCountsResponse>
      >(path);

      return res.data;
    },
  });
}
